export default "__VITE_ASSET__D48e9aYM__"